import { render, staticRenderFns } from "./ChangePasswordDialogue.vue?vue&type=template&id=51d8ca55&"
import script from "./ChangePasswordDialogue.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports